import { inject, Injectable } from '@angular/core';
import { AuthService } from './auth-service';
import { HttpService } from './http-service';
import { RetrieveAllFamiliesDataResponse } from '../dto/RetrieveAllFamiliesDataResponse';
import { RsvpDataResponse } from '../dto/RsvpDataResponse';
import { ModificationHistoryLine } from '../models/ModificationHistoryLine';

@Injectable({
  providedIn: 'root',
})
export class AnalyseService {

  private httpService: HttpService = inject(HttpService);
  private authService: AuthService = inject(AuthService);

  private readonly analyseSubPath = '/analyse';

  async getCompleteFamiliesData(): Promise<RetrieveAllFamiliesDataResponse> {
    this.authService.askToRefreshIfNeeded();
    return this.httpService.getToPromise<RetrieveAllFamiliesDataResponse>(`${this.analyseSubPath}/retrieve-all`);
  }

  getAllInvitations(): Promise<Blob> {
    this.authService.askToRefreshIfNeeded();
    return this.httpService.getBlobToPromise(`${this.analyseSubPath}/generate-all-invites`);
  }

  getSpecificInvitations(uuidList: string[]): Promise<Blob> {
    this.authService.askToRefreshIfNeeded();
    return this.httpService.postBlobToPromise(`${this.analyseSubPath}/generate-specific-invites`, JSON.stringify({ uuidList }));
  }

  getAllComments(): Promise<RsvpDataResponse[]> {
    this.authService.askToRefreshIfNeeded();
    return this.httpService.getToPromise(`${this.analyseSubPath}/comments`);
  }

  getAllBonuQuestionAnswer(): Promise<RsvpDataResponse[]> {
    this.authService.askToRefreshIfNeeded();
    return this.httpService.getToPromise(`${this.analyseSubPath}/answers`);
  }

  getAllModificationBetwin(from?: Date | null, to?: Date | null): Promise<ModificationHistoryLine[]> {
    this.authService.askToRefreshIfNeeded();
    return this.httpService.postToPromise<ModificationHistoryLine[]>(`${this.analyseSubPath}/history`, JSON.stringify({to, from}));
  }
}
